module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.unitPeriod) ? _c('span', {
    attrs: {
      "id": "plans"
    }
  }, [_c('div', {
    attrs: {
      "id": "plan-tabs"
    }
  }, [(_vm.plans.length > 1) ? _c('ul', _vm._l((_vm.plans), function(plan, index) {
    return _c('li', {
      key: plan.id,
      staticClass: "ds-main ds-color ds-border-color plan-tab",
      class: {
        inactive: _vm.activePlan != plan
      },
      on: {
        "click": function($event) {
          _vm.activePlanIndex = index, _vm.expand = false
        }
      }
    }, [_c('div', {
      staticClass: "plan-tab-name"
    }, [_vm._v(_vm._s(plan.plan.name))])])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.planNotes && _vm.planNotes.length > 0) ? _c('div', {
    staticClass: "plan-notes",
    class: {
      infocollapse: _vm.setCollapse
    }
  }, [_c('ul', {
    staticClass: "fa-ul"
  }, _vm._l((_vm.planNotes), function(note) {
    return _c('li', {
      key: note.id
    }, [_vm._m(0, true), _vm._v(" "), _c('div', [_vm._v(_vm._s(note.note))])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "plan-notes-button"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.expand),
      expression: "!expand"
    }],
    staticClass: "ellipsis",
    on: {
      "click": _vm.setExpand
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expand),
      expression: "expand"
    }],
    staticClass: "ellipsis",
    on: {
      "click": _vm.setCollapseBack
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "plan-types"
  }, _vm._l((_vm.planTypes), function(pt) {
    return _c('div', {
      key: pt[0],
      staticClass: "plan-type ds-main ds-color",
      class: {
        selected: _vm.selectedPlanType === pt,
        "ds-background": _vm.selectedPlanType === pt
      },
      on: {
        "click": function($event) {
          _vm.selectedPlanType = pt
        }
      }
    }, [_c('i', {
      staticClass: "fas",
      class: pt[1]
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(pt[0]))])])
  }), 0), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "up-down",
      "mode": "out-in"
    }
  }, [_vm._l((_vm.plans), function(plan) {
    return [(_vm.activePlan === plan) ? _c(_vm.selectedPlanType[0], {
      key: plan.id,
      tag: "component",
      attrs: {
        "termIdentifier": _vm.termIdentifier,
        "terms": _vm.formatTerms(plan.plan_terms),
        "special-requirements": _vm.specialRequirements
      }
    }) : _vm._e()]
  })], 2)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "fa-li"
  }, [_c('i', {
    staticClass: "fas fa-sticky-note",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-849ed9a0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/UnitPlans.vue
// module id = 1137
// module chunks = 1